<template>
    <header class="siteheader">
        <div class="siteheader__container">
            <LogoText></LogoText>
            <a class="siteheader__help" @click.prevent="openHeaderModal()">
                Besoin d'aide ?
<!--                <svg width="13" height="18" xmlns="http://www.w3.org/2000/svg">-->
<!--                    <path d="M12.917 5.524C12.893 4.03 12.723 2.34 10.911.86 9.931.06 9.381.21 8.777.673c-.696.53-1.887 1.77-2.185 2.485-.297.714.735 1.994 1.265 2.503.637.614.942.079 1.207.361.516.548-.115 3.066-.811 4.287-.683 1.198-2.52 3.01-3.247 2.832-.374-.092-.069-.626-.912-.879-.7-.21-2.311-.475-2.773.143-.462.618-.927 2.282-1.033 3.158-.093.76.053 1.32 1.227 1.779 2.171.85 3.701.153 4.992-.572.96-.54 3.078-2.26 4.555-4.85 1.463-2.567 1.874-5.285 1.855-6.396Z" fill="#FFF" fill-rule="evenodd"/>-->
<!--                </svg>-->
            </a>
        </div>
    </header>
</template>

<script>
import LogoText from "../_commons/fr/LogoText";
import InfosModal from "./modals/InfosModal.vue";
export default {
    name: "SiteHeader",
    components:{LogoText},
    props:{
        action:{
            type:String,
            default:'infos',
        }
    },
    methods:{
        openHeaderModal() {
            // if(this.action=='infos'){
            this.$buefy.modal.open({
                component: InfosModal,
                props: {
                    activeTab: 'faq'
                }
            })
            dataLayer.push({
                event:'openModal',
                step:this.$store.get('general_data/current_step'),
                eventSource: 'header',
                modalTab:'faq',
            })
            // } else {
            //     this.$buefy.modal.open({
            //         component: HelpModal,
            //     })
            // }
        }
    },
    computed: {
        formUrl() {
            return `${location.origin}/${window.slug}`
        }
    }
}
</script>

<style scoped>

</style>
